import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { isProductionLate, productionLeadDays } from '../../lib/production';

export const LateBadge = ({ opp, testId }) => {
    if (!isProductionLate(opp)) return null;
    const days = productionLeadDays(opp);
    return (
        <span
            className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded-full bg-red-600 text-white"
            title={`Solo ${days} giorni tra inizio produzione e consegna`}
            data-testid={testId}
        >
            <AlertTriangle size={10} /> Ritardo · {days}gg
        </span>
    );
};
